import React, { useMemo, useRef, useState} from "react";
import {navButtons} from "../../constants/copyright";
import {usePanel} from "../../redux/reducer/panel";
import Button from "../baseComponents/gui/button/Button";
import buttonStyles from "../baseComponents/gui/button/Button.module.scss";
import {safeHTML} from "../../utils/safeHTML";
import NewsAuthorBlock from "../news/NewsAuthorBlock";
import Tag from "../baseComponents/gui/tag/Tag";
import Sticky from "react-sticky-el";
import {Link} from "react-scroll";
import classNames from "classnames";
import AppearSensor from "../baseComponents/helpers/appearSensor/AppearSensor";
import Recommendations from "../recommendations/Recommendations";
import styles from "./Faq.module.scss";

const Faq = React.forwardRef(
  function Faq(props, ref) {
    const {
      title, tags, preview, author,
      comments, recommendation,
      content: {cards}
    } = props;
    const {buttonBack, buttonToTop} = navButtons;
    const {filter} = usePanel();
    const answersRef = useRef();
    const [active, setActive] = useState({});


    const activeId = useMemo(() => {
      return Object.entries(active).filter(v => v[1]).reduce((res, [index]) => Math.min(res, +index), Infinity);
    }, [active]);



    const questions = cards?.map(({title}, index) => (
      <Link legacyBehavior  to={`question-${index + 1}`} key={`question-${index}`}
            smooth={true}
            className={classNames(styles.faq__question, {
              [styles.faq__question_active]: activeId === index
            })}
      >
        <span className="dot"/>
        {safeHTML(title)}

      </Link>
    ));
    const answers = cards?.map(({title, text}, index) => (
      <AppearSensor key={`answer-${index}`} onChange={(isActive) => setActive(v => ({...v, [index]: isActive}))}>
        {({isVisible}) => {
          return (
            <div className={classNames(styles.faq__answer, {
              [styles.faq__answer_active]: isVisible
            })}>
              <h3>{safeHTML(title)}</h3>
              {safeHTML(text)}
              <div className={styles.faq__answerAnchor} id={`question-${index + 1}`}/>
            </div>)
        }}
      </AppearSensor>
    ))
    return (
      <section className={styles.faq} ref={ref}>
        <div className={styles.faq__content}>
          <Button routerUrl={filter ? filter : '/'} {...buttonBack}/>
          <div className={styles.faq__header}>
            <h1 className={styles.faq__title}>{safeHTML(title)}</h1>
            {author && <NewsAuthorBlock {...author}/>}
            <div className={styles.faq__tags}>
              {tags?.map((el, id) => <Tag key={`tag-${id}`} {...el}/>)}
            </div>
          </div>
          <div className={styles.faq__preview}>
            <img src={preview} alt="превью" loading="lazy"/>
          </div>
          <div className={styles.faq__body}>
            <Sticky mode={"top"} topOffset={-120} bottomOffset={120}
                    positionRecheckInterval={1}
                    hideOnBoundaryHit={true}
                    stickyStyle={{
                      top: '120px'
                    }}
                    className={styles.faq__questionsWrapper}
                    boundaryElement={styles.faq__body}
            >
              <div className={styles.faq__questions}>
                {questions}
              </div>
            </Sticky>

            <div className={styles.faq__answers} ref={answersRef}>
              {answers}
            </div>
          </div>

          {/*-<AppearSensor partialVisibility={true}>*/}
          {/*  {({hasBeenVisible}) =>*/}
          {/*    <Comments comments={comments} className={classNames("", {*/}
          {/*      "comments_show": hasBeenVisible*/}
          {/*    })}/>*/}
          {/*  }*/}
          {/*</AppearSensor>*/}
          <Recommendations title={"Рекомендуем"} list={recommendation} mod={"news"} showAnimation={true}/>
          <Button {...buttonToTop}
                  className={classNames(
                    buttonStyles.button_white,
                    buttonStyles.button_border,
                    buttonStyles.button_icon,
                    buttonStyles.button_toTop,
                  )}
                  onClick={() => scrollTo({top: 0, behavior: "smooth"})}
          />
        </div>
      </section>
    );
  });
export default Faq;
Faq.propTypes = {};

